import React from "react"
import Footer from "./footer"
import LandingPage from "./landingPage"
import Nav from "./nav"
import Projects from "./projects"
import ProjectOne from "./project_one"
import Skills from "./skills"





export default function Main (props)
{


    return(
        <div className="main_container">
                        <Nav/>
            <LandingPage/>
            <ProjectOne/>
            <Skills/>
            <Projects/>
            <Footer/>
        </div>
    )
}